'use client'

import Modal from 'lib/components/Modal/Modal'

import type { FC } from 'react'

export const SESSION_EXPIRED_MODAL_ID = 'session-expired-modal'

interface SessionExpiredModalProps {
  onCreateNewShipment: () => void
}

const SessionExpiredModal: FC<SessionExpiredModalProps> = ({ onCreateNewShipment }) => {
  return (
    <Modal
      id={SESSION_EXPIRED_MODAL_ID}
      persistent
      dialogPanelClass="max-w-[30rem]"
      title="Your session has expired."
      content={
        <p className="mb-8 text-center">
          Your order data was cleared out due to inactivity. Please try again.
        </p>
      }
      buttons={[
        {
          text: 'Create a New Shipment',
          onCTAClick: onCreateNewShipment,
        },
      ]}
    />
  )
}

export default SessionExpiredModal
